export { ProductDetailsNutritionEntriesList } from './ProductDetailsNutritionEntriesList';
